class BridgeMessagingAPI {
  static subscribe(callback) {
    window.addEventListener('message', callback, true);
    return () => window.removeEventListener('message', callback);
  }

  static sendEventToReactNative({ eventName, params }) {
    try {
      if (!window.ReactNativeWebView?.postMessage) {
        return null;
      }
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({ eventName, params })
      );
    } catch (error) {
      console.log(error);
      throw new Error(`Something went wrong during ${eventName} execution`);
    }
  }

  static handshake = () => {
    BridgeMessagingAPI.sendEventToReactNative({
      eventName: 'handshake',
      params: {}
    });
  };

  static closeWebview = () => {
    BridgeMessagingAPI.sendEventToReactNative({
      eventName: 'closeWebview',
      params: {}
    });
  };

  static setNoTopInsetRoutes(routes) {
    BridgeMessagingAPI.sendEventToReactNative({
      eventName: 'setNoTopInsetRoutes',
      params: { noTopInsetRoutes: routes }
    });
  }

  static setOriginWhitelist(origins) {
    BridgeMessagingAPI.sendEventToReactNative({
      eventName: 'setOriginWhitelist',
      params: { originWhitelist: origins }
    });
  }

  static setApplicationOriginWhitelist(origins) {
    BridgeMessagingAPI.sendEventToReactNative({
      eventName: 'setApplicationOriginWhitelist',
      params: { originWhitelist: origins }
    });
  }
}

export default BridgeMessagingAPI;
